<template>
    <el-container >
        <div :class="classObj" class="app-wrapper">
          <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
          <div class="sidebar-container">
            <!--              <el-aside width="initial" :collapse="isCollapse">-->
            <logo v-if="showLogo" :collapse="isCollapse" />
            <el-menu router unique-opened :collapse="isCollapse" >
              <el-submenu
                  :index="index+''"
                  v-for="(item,index) in routes" :key="index"
                  v-if="!item.hidden">
                <template slot="title">
                  <i :class="item.iconCls" style="color: #1accff;margin-right: 5px"></i>
                  <span class="item">{{item.name}}</span>
                </template>
                <el-menu-item :index="children.path" v-for="(children,indexs) in item.children" :key="indexs">
                  <i :class="children.iconCls" style="color: #1accff;margin-right: 5px"></i>
                  {{children.name}}
                </el-menu-item>
              </el-submenu>
            </el-menu>
            <!--              </el-aside>-->
          </div>
        </div>
      <el-container >
        <el-header class="homeHeader">
          <div id="hamburger-container" class="hamburger-container"  style="padding: 0px 15px;">
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="64" height="64" class="hamburger is-active" @click="toggleCollapse">
              <path d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z">
              </path>
            </svg>
          </div>
          <div >
            <template v-if="device!=='mobile'">
              <search id="header-search" class="right-menu-item" />
              <error-log class="errLog-container right-menu-item hover-effect" />
              <el-tooltip content="Global Size" effect="dark" placement="bottom">
                <size-select id="size-select" class="right-menu-item hover-effect" />
              </el-tooltip>
            </template>
            <el-dropdown @command="handleCommand" >
              <el-button type="primary" >
                <span style="display: flex;align-items: center;"><img src="@/assets/userimg_man.png" style="width:32px;height:32px;"></img>{{user.realName}}<i class="el-icon-arrow-down el-icon--right"></i></span>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-user-solid" command="userInfo">个人中心</el-dropdown-item>
                <el-dropdown-item icon="el-icon-s-tools" command="setting">设置</el-dropdown-item>
                <el-divider style="margin:5px 3px !important;"></el-divider>
                <el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="this.$router.currentRoute.path!='/home'">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{this.$router.currentRoute.name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-main>
            <div class="homeWelcome" v-if="this.$router.currentRoute.path=='/home'">
                欢迎来到首页
            </div>
            <keep-alive>
                <router-view class="homeRouterView"></router-view>
            </keep-alive>
        </el-main>
      </el-container>
    </el-container>
</template>

<script>

import ResizeMixin from '@/layout/ResizeHandler'
import { mapState } from 'vuex'
import {doLogout} from "@/api/oauht/oauth"
import Breadcrumb from '@/components/Breadcrumb'
import ErrorLog from '@/components/ErrorLog'
import SizeSelect from '@/components/SizeSelect'
import Logo from './Logo'
import FixiOSBug from './FixiOSBug'
import store from "@/store";

    export default {
      name: "Home",
      components: {
        Breadcrumb,
        ErrorLog,
        SizeSelect,
        Logo
      },
      data(){
        return{

        }
      },
      mixins: [ResizeMixin,FixiOSBug],
      methods: {
          handleCommand(command) {
              if (command=='logout'){
                  this.$confirm('此操作将注销登陆, 是否继续?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    store.state.routes=[];
                    doLogout();
                    this.$router.replace('/')
                  }).catch(() => {
                      this.$message({
                          type: 'info',
                          message: '已取消操作'
                      });
                  });

              }else if(command=='userInfo'){

              }else if(command=='setting'){
              }
          },
          toggleCollapse(){
            this.$store.dispatch('toggleSideBar')
          },
          showLogo() {
            return this.$store.state.settings.sidebarLogo
          },
          handleClickOutside() {
            this.$store.dispatch('closeSideBar', { withoutAnimation: false })
          },

      },
      computed:{
        ...mapState({
          sidebar: state => state.sidebar,
          device: state => state.device,
          // showSettings: state => state.showSettings,
          // needTagsView: state => state.tagsView,
          // fixedHeader: state => state.fixedHeader
        }),
        classObj() {
          return {
            hideSidebar: !this.sidebar.opened,
            openSidebar: this.sidebar.opened,
            withoutAnimation: this.sidebar.withoutAnimation,
            mobile: this.device === 'mobile'
          }
        },
        routes() {
          return this.$store.state.routes;
        },
        user(){
          return this.$store.state.user;
        },
        isCollapse() {
          return !this.sidebar.opened
        }
      },

    }
</script>

<style scoped lang="less">
    ::-webkit-scrollbar {
      display: none;
    }
    .fixed-header {
      position: fixed;
      top: 0;
      right: 0;
      z-index: 9;
      width: calc(100% - 260px);
      transition: width 0.28s;
    }
    .homeHeader{
        /*background: rgb(48, 65, 86);*/
        background: #409EFF;
        //background: #909399;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px 0px 0px;
        box-sizing: border-box;
    }
    .homeHeader .title{
        font-size: 30px;
        font-family: 微软雅黑;
        color: white;
    }
    .homeHeader .userInfo{
        cursor: pointer;
    }
    .el-dropdown img{
        width: 32px;
        height: 32px;
        border-radius: 24px;
        margin-left: 5px;
    }
    .homeWelcome{
        text-align: center;
        font-size: 30px;
        font-family: 微软雅黑;
        color: #409eff;
        padding-top: 50px;
    }
    .homeRouterView{
        margin-top: 10px;
    }
    .item {
      font-size: 14px;
      color: #ffffff;
      padding: 0 20px;
      cursor: pointer;
      transition: border-color .3s, background-color .3s, color .3s;
      box-sizing: border-box;
    }
    .el-submenu .el-menu-item {
      font-size: 14px;
      background-color: #1f2d3d !important;
      color: #f6f6f8;
      height: 50px;
      line-height: 50px;
      padding: 0 45px;
      min-width: 200px;
    }
    .el-aside{
      //font-size: 100px;
      height: 100vh;
      background-color: rgb(48, 65, 86);
      overflow: auto;
    }
    .el-menu{
      background-color: rgb(48, 65, 86);
    }
    .el-menu:not(.el-menu--collapse) {
      width: 260px;
    }
    .el-submenu /deep/.el-submenu__title:hover {
      background-color: #1f2d3d !important;
    }
    //设置鼠标悬停时el-menu-item的样式
    .el-menu-item:hover{
      background-color: rgb(45, 43, 44) !important;
      color: #38B2FF !important;
      //less语法，实现鼠标悬停时icon变色
      i {
        color: #38B2FF;
      }
    }
    //设置选中el-menu-item时的样式
    .el-menu-item.is-active {
      background-color: rgb(27, 35, 47) !important;
      color: #38B2FF !important;
    }
    .hamburger {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      fill: #fff;
    }
    .drawer-bg {
      background: #000;
      opacity: .3;
      width: 100%;
      top: 0;
      height: 100%;
      position: absolute;
      z-index: 999;
    }
    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }
    }
    /*菜单自适应*/
    #app .mobile.hideSidebar .sidebar-container {
      position: fixed;
      pointer-events: none;
      -webkit-transition-duration: .3s;
      transition-duration: .3s;
      -webkit-transform: translate3d(-260px, 0, 0);
      transform: translate3d(-260px, 0, 0);
    }
    #app .mobile .sidebar-container {
      position: fixed;
      -webkit-transition: -webkit-transform .28s;
      transition: -webkit-transform .28s;
      transition: transform .28s;
      transition: transform .28s, -webkit-transform .28s;
      width: 210px !important;
    }

    #app .hideSidebar .sidebar-container {
      width: 60px !important;
    }
    #app .sidebar-container {
      -webkit-transition: width .28s;
      transition: width .28s;
      width: 260px !important;
      background-color: #304156;
      height: 100%;
      position: relative;
      /*position: fixed;*/
      font-size: 0;
      top: 0;
      bottom: 0;
      left: 0;
      z-index: 1001;
      overflow: auto;
    }
    .el-breadcrumb{
      line-height: 2.5rem;
      background: #dcdcdc;
      padding: 0px 1rem;
    }

</style>
